import React from 'react'

export const SkeletonAnimation = () => {
    return (
        <div className='shimmer-wrapper'>
            <div className='shimmer'>

            </div>
        </div>
    )
}
